import { GET_ADMIN_BANK_LIST,GET_ADMIN_BANK_LIST_ERROR,GET_ADMIN_BANK_LIST_REQUEST,UPDATE_ADMIN_BANK_LIST_DATA,REMOVE_ADMIN_BANK_LIST_DATA } from "../ActionTypes/ActionTypes.js";

const initialState = {
    adminBankListLoading: false,
    adminBankListData: null,
    adminBankListError: null,
    adminBankListStatus: null,
    isModified: false,
    isFirstLoad: true,


};

const adminBankListReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_ADMIN_BANK_LIST_REQUEST:
            return { ...state, adminBankListLoading: state.isFirstLoad};
        case GET_ADMIN_BANK_LIST:
            return {
                adminBankListLoading: false, adminBankListData: action.payload, adminBankListError: null, adminBankListStatus: true,

                isFirstLoad: false,
            };

        case GET_ADMIN_BANK_LIST_ERROR:
            return { adminBankListLoading: false, adminBankListData: null, adminBankListError: action?.payload, adminBankListStatus: false, isFirstLoad: false, };
        case UPDATE_ADMIN_BANK_LIST_DATA:
            return {
                ...state,
                adminBankListData: {
                    ...state.adminBankListData,
                    result: {
                        ...state.adminBankListData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_ADMIN_BANK_LIST_DATA:
            return { ...state, adminBankListData: null, adminBankListError: null, isModified: false, adminBankListStatus: null, isFirstLoad: true, adminBankListLoading: false }
        default:
            return state;
    }
};

export default adminBankListReducer;